function escapeQueryTerm(term) {
  // eslint-disable-next-line
  const pattern = /([\!\*\+\-\=\<\>\&\|\(\)\[\]\{\}\^\~\?\:\\/"])/g;
  const escapedTerm = term.replace(pattern, "\\$1");
  return escapedTerm;
}
export default escapeQueryTerm;